import { render, staticRenderFns } from "./match-referee-score-view.vue?vue&type=template&id=2daebef8"
import script from "./match-referee-score-view.vue?vue&type=script&lang=js"
export * from "./match-referee-score-view.vue?vue&type=script&lang=js"
import style0 from "./match-referee-score-view.vue?vue&type=style&index=0&id=2daebef8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports